import { observable, action, runInAction } from 'mobx';
import { isEmpty, cloneDeep } from 'lodash';

import ResearchService from '@service/industry-research';
import moIndex from '../../store/index';

const moScale = observable({
  companyScale: <any[]>[],
  companyProperty: <any[]>[],
});

// 公司规模分布
const getScaleData = action(async (res: any) => {
  const arr: any[] = cloneDeep(res) || [];
  const newArr: any[] = [];
  arr.map(item => {
    if (item.ratio >= 0.001) newArr.push(item);
  });
  for (let i = 0; i < newArr.length; i += 1) {
    if (i === 0) newArr[0].prop = 'one';
    if (i === 1) newArr[1].prop = 'two';
    if (i === 2) newArr[2].prop = 'three';
    if (i === 3) newArr[3].prop = 'four';
    if (i === 4) newArr[4].prop = 'five';
    if (i === 5) newArr[5].prop = 'six';
    if (i === 6) newArr[6].prop = 'seven';
  }
  runInAction(() => { moScale.companyScale = newArr; });
});

// 公司性质分布
const getPropertyData = action(async (res: any) => {
  const arr: any[] = cloneDeep(res) || [];
  const newArr: any[] = [];
  arr.map(item => {
    if (item.ratio >= 0.001) newArr.push(item);
  });
  for (let i = 0; i < newArr.length; i += 1) {
    if (i === 0) newArr[0].prop = 'one';
    if (i === 1) newArr[1].prop = 'two';
    if (i === 2) newArr[2].prop = 'three';
    if (i === 3) newArr[3].prop = 'four';
    if (i === 4) newArr[4].prop = 'five';
    if (i === 5) newArr[5].prop = 'seven';
  }
  runInAction(() => { moScale.companyProperty = newArr; });
});

export default moScale;
export { getPropertyData, getScaleData };
